import relativeDate from '@/filters/relativeDate';

interface ScheduledItem {
    due_at: string;
    not_before: string;
    is_resolvable: boolean;
    url: string;
    status: {
        value: string;
    };
}

export function scheduledItemAvailableIn(item: ScheduledItem, locale = 'en') {
    if (item?.is_resolvable === true) {
        return null;
    }

    if (item.not_before) {
        return relativeDate(item.not_before, locale);
    }

    return null;
}
